module.exports = __webpack_public_path__ + "static/media/star.084ba35b.svg";